import { ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { goBack } from '../../../util/go_back.ts';
import { BackButton, BackButtonPlaceholder } from '../org/shared.tsx';
import { useInternalPage } from '../use_internal_page.tsx';

export const EngineeringAdminWrapper = ({
  children,
  title,
  allowInDev,
}: {
  children: ReactNode;
  title: string;
  allowInDev?: boolean;
}) => {
  useInternalPage({ allowInDev });
  const navigate = useNavigate();

  const onBack = useCallback(async () => {
    await goBack(navigate);
  }, [navigate]);

  return (
    <OuterWrapper key="outer-wrapper">
      <Header key="header">
        <BackButton key="back-button" onClick={onBack} />
        <BackButtonPlaceholder key="back-button-placeholder" onClick={onBack} />
        <Title key="title">{title}</Title>
      </Header>
      <ScrollableContent>{children}</ScrollableContent>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div``;

const HeaderHeight = '3.5rem';

const Header = styled.div`
  height: ${HeaderHeight};
  display: flex;
  align-items: center;
`;

const ScrollableContent = styled.div`
  height: calc(100vh - ${HeaderHeight});
  overflow: scroll;
`;

const Title = styled.h1`
  margin-left: 5px;
  text-align: left;
`;

export const SubHeader = styled.h2`
  text-align: left;
`;
export const EngineeringButtonWrapper = styled.button`
  font-family: Jost-SemiBold, Arial, sans-serif;
  font-size: 1.3rem;
  color: var(--color-text);
  padding: 0 15px;
  margin: 10px 0;
  border: 2px solid var(--color-text);
  border-radius: 10px;
  background-color: var(--color-background);
  cursor: pointer;
`;
